module.exports = __webpack_public_path__ + "static/img/share.2340bd0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/share.jpg
// module id = TmAL
// module chunks = 34